export default "__VITE_ASSET__DBGj62mV__"